import { CookieManagerService } from './../../shared/services/cookie-manager.service';
import { CookieNames } from './../constant';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LocalStorageService } from 'angular-2-local-storage';
import { HttpClientService } from '../../shared';
import { ApiEndpoints } from '../constant';
declare var $: any;

@Injectable()
export class SubscriptionInfoService {

  private packageSource = new BehaviorSubject("Defualt");
  private currentPackageSource = new BehaviorSubject("Defualt");
  currentMessage = this.packageSource.asObservable();
  currentPackageSourceMsg = this.currentPackageSource.asObservable();

  private currentPackge: any;

  constructor(
    private localStorageService: LocalStorageService,
    private cookieManagerService: CookieManagerService,
    private httpClientService: HttpClientService,
  ) { }

  selectPackage(subscriptionPackage: string) {
    this.packageSource.next(subscriptionPackage);
    this.localStorageService.set("SubscriptionPackage", JSON.stringify(subscriptionPackage));
  }

  setSelectedPackage(subscriptionPackage) {
    this.localStorageService.set("SubscriptionPackage", JSON.stringify(subscriptionPackage));
  }

  getSelectedPackage() {
    let selectedPackageObj = this.localStorageService.get("SubscriptionPackage");
    if (selectedPackageObj) {
      return JSON.parse(selectedPackageObj.toString());
    }
    else {
      return null;
    }
  }

  getUserSubscribedPackage() {
    return this.localStorageService.get(CookieNames.userPackageId);
  }

  setCurrentSubscriptionPackage(subscriptionPackageId: string) {
    if (subscriptionPackageId === "") {
      this.localStorageService.remove(CookieNames.userPackageId);
    }
    else {
      this.localStorageService.set(CookieNames.userPackageId, subscriptionPackageId);
    }
    this.currentPackageSource.next(subscriptionPackageId);
  }

  checkSubscriptionStatus(count, userMobile, requestedPackageId, action) {
    return new Promise((resolve, reject) => {
        this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.checkUserSubscriptionStatus, { [ApiEndpoints.mobile]: userMobile, [ApiEndpoints.requestedPackageId]: requestedPackageId, [ApiEndpoints.action]: action }), null).subscribe(response => {
           if (response && response.isSubscriptionSuccess) {
            resolve(response);
          }
          else{
            resolve(response);
          }
        });

    });
  }

  subscribeForLive(userMobile, requestedPackageId) {

    return new Promise((resolve, reject) => {
      this.httpClientService.authPost(ApiEndpoints.replaceParms(ApiEndpoints.liveExamToSubscribers, { [ApiEndpoints.mobile]: userMobile, [ApiEndpoints.requestedPackageId]: requestedPackageId }), null).subscribe(response => {
        resolve(response);

      });

    });
  }

  toggleSubscriptionPopup(){
    let subscriptionCount = parseInt(this.cookieManagerService.getCookie(CookieNames.subscriptionCount, false));
    if (subscriptionCount === 0) {
      $('#packages-pop').modal('show');
    }
  }
}





// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/subscription-packages/subscription-info-service.service.ts